import React from "react";
import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

// Masked line reveal: wraps children in overflow-hidden and slides up
export const MaskReveal = ({ children, delay = 0, className = "", as: Tag = "span" }) => (
  <span className="reveal-mask">
    <motion.span
      initial={{ y: "110%" }}
      whileInView={{ y: "0%" }}
      viewport={{ once: true, margin: "-10%" }}
      transition={{ duration: 0.9, ease: EASE, delay }}
      className={`block ${className}`}
    >
      {children}
    </motion.span>
  </span>
);

// Fade + slide up on scroll into view
export const Reveal = ({ children, delay = 0, y = 40, className = "", once = true }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-8%" }}
    transition={{ duration: 0.8, ease: EASE, delay }}
    className={className}
  >
    {children}
  </motion.div>
);

export { EASE };
